import React, { useEffect, useState } from "react";
import { Tab, Nav } from 'react-bootstrap';
import InsuranceListTable from '@src/component/insurance/list/InsuranceListTable';
import InsuranceListTopFilter from '@src/component/insurance/list/InsuranceListTopFilter';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux'
import { exportInsuranceData, getInsuranceList, leadListFilters, exportInsuranceAllData } from '@src/store/slices/insurance';
import FullPageLoader from '@src/common/FullPageLoader';
import { useSelector } from 'react-redux';
import { toast } from "react-toastify";
import { getUserList } from "@src/store/slices/user";
import { COUNTRY_CODE, FEATURE_LISTING, PAGE_NUMBER, ROLE_FEATURES, STATUS_SUCCESS } from "@src/config/constant";
import * as HELPER from "@src/config/helper";
import ReactSelect from "@common/ReactSelect";
import Modal from "@src/common/ModalPopup";
import BulkImportModal from "@src/component/rule-engine/import/BulkImportModal";
import secureStorage from '../../../config/encrypt';
import { useLanguage } from "@src/context/LanguageContext";
const isCountryId = COUNTRY_CODE ==='id' ? true : false;


function InsuranceList() {
    const navigate = useNavigate();
    const dispatch: any = useDispatch();

    const [searchParams, setSearchParams] = useSearchParams();

    const insuranceState = useSelector((state: any) => state.insurance);
    const commonState = useSelector((state: any) => state.common);
    const {translations} = useLanguage();
    

    let authUserInfo:any = secureStorage.getItem('authUserInfo');

    const [loading, setLoading] = useState<boolean>(false);
    const [insuranceList, setInsuranceList] = useState<any>([]);
    const [paginationData, setPaginationData] = useState<any>({});
    const [selectedFilters, setSelectedFilters] = useState<any>({ page_number: PAGE_NUMBER, activeTab: HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['my_cases'], accessType: 'isVisible' }) ? "all" : "all" });
    const [assignUsers, setAssignUsers] = useState<any>([]);
    const [listSort, setListSort] = useState<any>({});
    const [bulkUploadModal, setBulkUploadModal] = useState<any>(false);

    let searchKeywordParam: any = searchParams.get('searchKeyword');
    let statusParam: any = searchParams.get('status_id_arr');
    let subStatusParam: any = searchParams.get('sub_status_id_arr');
    let applicationType: any = searchParams.get('application_type');
    let filterTypeParam: any = searchParams.get('filterType');

    const addNewApp = () => {
        navigate('/create-insurance-policy?step=insurance_form');
    }

    useEffect(() => {
        const getAllUsers = () => {
            getUserList({ role_id: 3, page_number: PAGE_NUMBER, isPaginationApply: false }).then((res: any) => {
                if (res.status === STATUS_SUCCESS && res.data && res.data.length) {
                    setAssignUsers(res.data.map((user: any) => { return { label: user.name, value: user.id } }));
                }
            })
        }


        getAllUsers()

    }, []);

    // useEffect(() => {
    //     getInsuranceListing({});

    // }, []);

    useEffect(() => {

        let updatedSelctedFilters: any = {...selectedFilters};

        if (searchKeywordParam) {
            updatedSelctedFilters['searchKeyword'] = searchKeywordParam;
        }

        if (statusParam) {
            updatedSelctedFilters['status_id_arr'] = statusParam.split(",").map((v: any) => +v);
        }

        if (subStatusParam) {
            updatedSelctedFilters['sub_status_id_arr'] = subStatusParam.split(",").map((v: any) => +v);
        }

        if (applicationType) {
            updatedSelctedFilters['apptype'] = applicationType.split(",").map((v: any) => +v);
        }

        if (filterTypeParam) {
            updatedSelctedFilters['filterType'] = filterTypeParam;
        }

        if (!searchKeywordParam && !statusParam && !subStatusParam) {
            updatedSelctedFilters = { page_number: selectedFilters.page_number, activeTab: selectedFilters.activeTab };
        } else {

            setSelectedFilters((prev: any) => { return { ...prev, ...updatedSelctedFilters }; });
        }

        getInsuranceListing(updatedSelctedFilters);

        // eslint-disable-next-line
    }, [searchKeywordParam, statusParam, subStatusParam])

    useEffect(() => {
        if (Object.keys(insuranceState.insuranceListFilters).length) {
            setSelectedFilters({ ...insuranceState.insuranceListFilters });
        }
    }, [insuranceState])

    //GET INSURANCE LIST API
    const getInsuranceListing = (params: any) => {
        let filters = {
            activeTab: HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['my_cases'], accessType: 'isVisible' }) ? "all" : "all",
            // ...selectedFilters,
            ...params,
            page_number: params?.page_number ?? PAGE_NUMBER,
        }

        if (filters['dateType']) {
            let errorFilter = false;
            if (!filters['from_date'] && !filters['to_date']) {
                errorFilter = true;
                toast.error("From Date and To Date are required");
            } else if (filters['from_date'] && filters['to_date'] && new Date(filters['from_date']).getTime() > new Date(filters['to_date']).getTime()) {
                errorFilter = true;
                toast.error("To Date should be greater than From Date");
            }

            if (errorFilter) return false;
        }

        dispatch(leadListFilters(filters));

        setLoading(true);
        // for searching customer as encrypt and then decrypt backend
        let modifiedFilters = { ...filters };

        if(isCountryId && modifiedFilters?.lead_source_type){            
            modifiedFilters = { ...modifiedFilters, lead_source_type: modifiedFilters?.lead_source_type?.flat()}
        }
        

        if (params?.searchKeyword) {
            modifiedFilters.searchKeyword = HELPER.EncodetoBase64(params?.searchKeyword);
        }
        dispatch(getInsuranceList(modifiedFilters)).then((res: any) => {
            setLoading(false)
            if (res && res.status === STATUS_SUCCESS) {
                setPaginationData({ ...res.pagination })
                setInsuranceList([])
                if(modifiedFilters?.activeTab && (res?.pagination?.[modifiedFilters?.activeTab+'CasesCount'] || (modifiedFilters?.activeTab === "myCases" && res?.pagination?.['myCasesCount']))){

                    setInsuranceList([...res.data])
                }
            }
        }).catch((err: Error) => {
            setLoading(false)
        })
    }

    const activeTabHandler = (tab: any) => {
        if (tab === "third") {
            getInsuranceListing({ ...selectedFilters, page_number: PAGE_NUMBER, activeTab: "disbursed" })
        } else if (tab === "fourth") {
            getInsuranceListing({ ...selectedFilters, page_number: PAGE_NUMBER, activeTab: "lost" })
        } else if (tab === "first") {
            getInsuranceListing({ ...selectedFilters, page_number: PAGE_NUMBER, activeTab: "myCases" })
        } else if (tab === "second") {
            getInsuranceListing({ ...selectedFilters, page_number: PAGE_NUMBER, activeTab: "all" })
        }
    }

    const handleSeeMoreClick = () => {
        let seeMore: any = document.getElementsByClassName('username-see-more')?.[0]
        //disable old Li elements
        if (seeMore.textContent === `- ${selectedFilters['username']?.length - 5} more`) {
            let documents: any = document.getElementsByClassName('to-hide')
            seeMore.textContent = `+ ${selectedFilters['username']?.length - 5} more`

            while (documents?.length) {
                documents[0].classList.add("hide");
                documents[0].classList.remove("to-hide");
            }

        } else {
            //enable hidden Li elements
            let documents: any = document.getElementsByClassName('hide')
            seeMore.textContent = `- ${selectedFilters['username']?.length - 5} more`

            while (documents?.length) {
                documents[0].classList.add("to-hide");
                documents[0].classList.remove("hide");
            }

        }
    }

    /**
     * MAKE FILTER VALUES CHIPS
     * @returns 
     */
    const makeFilterChips = () => {
        let chipsHtml = [];
        
        if (Object.keys(insuranceState.insuranceListFilters).length) {

            for (let filterKey of Object.keys(insuranceState.insuranceListFilters)) {
                if (filterKey === "page_number") continue;

                if (
                    ['insurer_id', 'partner_id', 'status_id_arr', 'sub_status_id_arr',
                        'created_by_ids', 'lead_source', 'username', 'apptype',
                        'lead_source_type', 'vehicle_type', 'priority'
                    ].includes(filterKey)
                    && insuranceState.insuranceListFilters[filterKey]
                ) {

                    if (filterKey === 'username' && insuranceState.insuranceListFilters[filterKey]?.length > 5) {
                        for (let [indx, value] of insuranceState.insuranceListFilters[filterKey].entries()) {
                            const stateValue = commonState?.sfaUserList || [];
                            const fetchRec = stateValue.find((el: any) => +el.value === +value);

                            if (!fetchRec) continue;

                            chipsHtml.push(
                                <li
                                    key={`username-${value}`}
                                    className={indx >= 5 ? 'hide' : ''}
                                >
                                    {fetchRec.label}
                                    <span onClick={() => onFilterChipRemove('username', value)}>
                                        <i className="ic-clearclose"></i>
                                    </span>
                                </li>
                            );
                        }

                        if (insuranceState.insuranceListFilters[filterKey].length > 5) {
                            chipsHtml.push(
                                <li
                                    key="username-see-more"
                                    className="username-see-more cursor-pointer"
                                    onClick={handleSeeMoreClick}
                                >
                                    {`+ ${insuranceState.insuranceListFilters[filterKey].length - 5} More`}
                                </li>
                            );
                        }
                    }

                    else {

                        const filterValue = insuranceState.insuranceListFilters[filterKey];
                        const filterValuesArray = Array.isArray(filterValue)
                            ? filterValue
                            : [filterValue];
                        for (let filterVal of filterValuesArray) {

                            let stateValue: any[] = [];

                            switch (filterKey) {
                                case 'apptype':
                                    stateValue = commonState?.common?.apptype;
                                    break;
                                case 'partner_id':
                                    stateValue = commonState?.common?.partner_list;
                                    break;
                                case 'status_id_arr':
                                    stateValue = commonState?.common?.status_list;
                                    break;
                                case 'sub_status_id_arr':
                                    stateValue = commonState?.common?.sub_status_list;
                                    break;
                                case 'created_by_ids':
                                    stateValue = commonState?.common?.insurance_role;
                                    break;
                                case 'lead_source':
                                    stateValue = commonState?.common?.lead_source;
                                    break;
                                case 'lead_source_type':
                                    stateValue = commonState?.common?.lead_source_type;
                                    break;
                                case 'vehicle_type':
                                    stateValue = commonState?.common?.vehicle_type;
                                    break;
                                case 'insurer_id':
                                    stateValue = commonState?.common?.insurer_list;
                                    break;
                                case 'priority':
                                    stateValue = commonState?.common?.priority;
                                    break;
                                default:
                                    stateValue = [];
                            }
                            
                            let fetchRec:any = stateValue?.filter((el: any, key: number) => +filterVal === (COUNTRY_CODE === 'id' ? el.lead_type : el.value)) || []; 


                            if (!fetchRec) continue;
                            // code for PH for priority task
                            if(!COUNTRY_CODE){
                                chipsHtml.push(
                                    <li key={`${filterKey}-${filterVal}`}>
                                        {filterKey === 'priority'
                                            ? `Priority: ${fetchRec.label}`
                                            : fetchRec.label
                                        }
                                        <span onClick={() => onFilterChipRemove(filterKey, filterVal)}>
                                            <i className="ic-clearclose"></i>
                                        </span>
                                    </li>
                                );

                            }else{
                                 // code for ID
                                 if (fetchRec && fetchRec[0]) {
                                chipsHtml.push(
                                    <li key={filterKey + filterVal}>
                                        {fetchRec[0]['label']}
                                        <span onClick={() => onFilterChipRemove(filterKey, filterVal)}>
                                            <i className="ic-clearclose"></i>
                                        </span>
                                    </li>
                                )
                            }
                            }                        
                        }
                    }
                }

                else if (filterKey === "searchKeyword" && insuranceState.insuranceListFilters[filterKey]) {

                    chipsHtml.push(
                        <li key={filterKey}>
                            {insuranceState.insuranceListFilters[filterKey]}
                            <span onClick={() => onFilterChipRemove(filterKey, '')}>
                                <i className="ic-clearclose"></i>
                            </span>
                        </li>
                    );
                } else if (["from_date"].includes(filterKey) && insuranceState.insuranceListFilters[filterKey]) {
                    // in chip content date range show combine together
                    let chipContent = insuranceState.insuranceListFilters["from_date"];
                    if (insuranceState.insuranceListFilters["from_date"]) {
                        if (insuranceState.insuranceListFilters["to_date"] !== null) {
                            chipContent += " ~ " + insuranceState.insuranceListFilters["to_date"];
                        }
                    }
                    chipsHtml.push(
                        <li key={filterKey}>
                            {chipContent}
                            <span onClick={() => onFilterChipRemove(filterKey, '')}>
                                <i className="ic-clearclose"></i>
                            </span>
                        </li>
                    );
                } else if (["from_due_date"].includes(filterKey) && insuranceState.insuranceListFilters[filterKey]) {
                    // in chip content date range show combine together
                    let chipContent = insuranceState.insuranceListFilters["from_due_date"];
                    if (insuranceState.insuranceListFilters["from_due_date"]) {
                        if (insuranceState.insuranceListFilters["to_due_date"] !== null) {
                            chipContent += " ~ " + insuranceState.insuranceListFilters["to_due_date"];
                        }
                    }
                    chipsHtml.push(
                        <li key={filterKey}>
                            {chipContent}
                            <span onClick={() => onFilterChipRemove(filterKey, '')}>
                                <i className="ic-clearclose"></i>
                            </span>
                        </li>
                    );
                }else if (["policy_effectivity_date_from"].includes(filterKey) && insuranceState.insuranceListFilters[filterKey]) {
                    // in chip content date range show combine together
                    let chipContent = insuranceState.insuranceListFilters["policy_effectivity_date_from"];
                    if (insuranceState.insuranceListFilters["policy_effectivity_date_to"]) {
                        chipContent += " ~ " + insuranceState.insuranceListFilters["policy_effectivity_date_to"];
                    }
                    chipsHtml.push(
                        <li key={filterKey}>
                            {chipContent}
                            <span onClick={() => onFilterChipRemove(filterKey, '')}>
                                <i className="ic-clearclose"></i>
                            </span>
                        </li>
                    );
                } else if (["policy_expiry_date_from"].includes(filterKey) && insuranceState.insuranceListFilters[filterKey]) {
                    // in chip content date range show combine together
                    let chipContent = insuranceState.insuranceListFilters["policy_expiry_date_from"];
                    if (insuranceState.insuranceListFilters["policy_expiry_date_to"]) {
                        chipContent += " ~ " + insuranceState.insuranceListFilters["policy_expiry_date_to"];
                    }
                    chipsHtml.push(
                        <li key={filterKey}>
                            {chipContent}
                            <span onClick={() => onFilterChipRemove(filterKey, '')}>
                                <i className="ic-clearclose"></i>
                            </span>
                        </li>
                    );
                }
                else {
                    
                    let stateValue = [];
                    if (["insurance_type_id", "tenure_insurance_type"].includes(filterKey)) {
                        stateValue = commonState?.common?.insurance_type
                    } else if (filterKey === "rule_engine_id") {
                        stateValue = commonState?.common?.rule_engine
                    } else if (filterKey === "dateType") {
                        stateValue = commonState?.common?.sub_status_list
                    } else if (filterKey === "employee_type") {
                        stateValue = commonState?.common?.employee_type
                    } else if (filterKey === "business_line") {
                        stateValue = commonState?.common?.business_lines
                    } else if (filterKey === "user_role") {
                        stateValue = commonState?.common?.sfa_roles
                    } else if (filterKey === "payment_status") {
                        stateValue = commonState?.common?.paid_by_customer
                    } else if (filterKey === "renewal_status") {
                        stateValue = commonState?.common?.paid_by_customer
                    }else if (filterKey === "raised_soa") {
                        stateValue = commonState?.common?.raised_soa
                    }else if (filterKey === "vehicle_usage") {
                        stateValue = commonState?.common?.vehicle_usage
                    }

                    let fetchRec = stateValue?.filter((el: any, key: number) => {
                        return filterKey !== 'business_line' ? +insuranceState.insuranceListFilters[filterKey] === +el.value : insuranceState.insuranceListFilters[filterKey] === el.value
                    }) || [];
                   
                    if (fetchRec && fetchRec[0]) {

                        chipsHtml.push(
                            <li key={filterKey}>
                                {((["payment_status", "renewal_status","raised_soa"].includes(filterKey)) ? (filterKey.replace("_"," "))+': ' : '') + fetchRec[0]['label']}
                                <span onClick={() => onFilterChipRemove(filterKey, '')}>
                                    <i className="ic-clearclose"></i>
                                </span>
                            </li>
                        );
                    }
                }
            }

        }

        return chipsHtml;
    }

    const onFilterChipRemove = (filterKey: string, filterVal: any) => {
        if (filterVal) {

            const currentVal = selectedFilters[filterKey];
            const currentArr = Array.isArray(currentVal) ? currentVal : [currentVal];

            selectedFilters[filterKey] = currentArr.filter(
                (el: any) => el !== filterVal
            );

            if (filterKey === 'username') {
                let seeMore: any = document.getElementsByClassName('username-see-more')?.[0]
                if (seeMore) {
                    let prevNumber = seeMore?.textContent?.split(' ')?.[1]
                    seeMore.textContent = seeMore.textContent.replace(prevNumber, selectedFilters[filterKey]?.length - 5)
                }
            }

            if (filterKey === "status_id_arr") {
                //RESET SUBSTATUS IF STATUS UPDATED
                let getAllSubstatusOfRemovedStatus: any = commonState?.common?.sub_status_list?.filter((el:any)=> +el.status_id === +filterVal)?.map((elm:any)=>elm.value);
                let updatedSubStatusFilter = selectedFilters?.sub_status_id_arr ? selectedFilters?.sub_status_id_arr?.filter((el:any)=> !getAllSubstatusOfRemovedStatus.includes(el)) : [];
                updatedSubStatusFilter = updatedSubStatusFilter.filter((el:any)=> el.value);

                selectedFilters['sub_status_id_arr'] = updatedSubStatusFilter?.length ? updatedSubStatusFilter : undefined;
            }

            if(filterKey === 'apptype' && !selectedFilters[filterKey]?.length) {
                delete selectedFilters[filterKey]; 
            }

            if (filterKey === 'priority' && !selectedFilters[filterKey]?.length) {
                delete selectedFilters[filterKey];
            }
        
        } else {
            if(filterKey === 'user_role') {
                delete selectedFilters['username']
            }

            if(filterKey === 'vehicle_usage') {
                delete selectedFilters['vehicle_type']
            }
            delete selectedFilters[filterKey];
        }

        //REMOVE FROM URL
        // if (!selectedFilters[filterKey] || (selectedFilters[filterKey] && !selectedFilters[filterKey].length)) {
        //     updateUrl(filterKey);
        // }

        if (filterKey === "dateType") {
            delete selectedFilters["from_date"];
            delete selectedFilters["to_date"];

        }
        // for resting date range
        if (filterKey === "from_date") {
            delete selectedFilters["from_date"];
            delete selectedFilters["to_date"];
        }

        if (filterKey === "policy_effectivity_date_from") {
            delete selectedFilters["policy_effectivity_date_from"];
            delete selectedFilters["policy_effectivity_date_to"];
        }

        if (filterKey === "policy_expiry_date_from") {
            delete selectedFilters["policy_expiry_date_from"];
            delete selectedFilters["policy_expiry_date_to"];
        }

        selectedFilters['page_number'] = 1;

        setSelectedFilters(selectedFilters);


        getInsuranceListing(selectedFilters);

    }

    /**
     * SORT LIST
     * @param event 
     */
    const sortByhandleChange = (event: any) => {
        setListSort({});
        
        if (event['value']) {
            getInsuranceListing({ ...selectedFilters, sortBy: event, page_number: PAGE_NUMBER });
            setListSort(event)
        }
    }

    useEffect(()=>{
        const options = translations?.Insurance?.INSURANCE_LIST_SORT || translations?.commonMsg?.loading;
        const selectedSort = options?.find((opt:any) => opt.value === listSort) || options?.[0];
        setListSort(selectedSort);
        // eslint-disable-next-line
    },[translations])

    const updateUrl = (filterKey: string) => {
        if(filterKey === 'resetAll'){
            if(searchParams.size){

                searchParams.delete('status_id_arr');
                searchParams.delete('sub_status_id_arr');
                searchParams.delete('filterType');
                searchParams.delete('searchKeyword');
                delete selectedFilters['status_id_arr'];
                delete selectedFilters['sub_status_id_arr'];
                delete selectedFilters['searchKeyword'];
                delete selectedFilters[filterKey];

                setSearchParams(searchParams);
                setSelectedFilters(selectedFilters);

                getInsuranceListing({activeTab: selectedFilters.activeTab || undefined});

            }else{

                getInsuranceListing({activeTab: selectedFilters.activeTab || undefined});

            }
        }else{
            //REMOVE FROM URL
            searchParams.delete(filterKey);
            delete selectedFilters[filterKey];
            setSearchParams(searchParams);
            setSelectedFilters(selectedFilters);
        }
    }

    const updateListFromChlid = (filterParams: any) => {
        // if (!filterParams['status_id_arr'] || (filterParams['status_id_arr'] && !filterParams['status_id_arr'].length)) {

        //     updateUrl("status_id_arr");
        // }

        // if (!filterParams['sub_status_id_arr'] || (filterParams['sub_status_id_arr'] && !filterParams['sub_status_id_arr'].length)) {

        //     updateUrl("sub_status_id_arr");
        // }


        getInsuranceListing(filterParams);

    }

    const handleExport = async () => {
        setLoading(true)
        const filterParams = insuranceState?.insuranceListFilters || { page_number: PAGE_NUMBER }
        const exportData: any = await exportInsuranceData(filterParams)
        setLoading(false)

        if(exportData?.status === STATUS_SUCCESS && exportData.message) {
            toast.success(exportData.message)
        } else {
            toast.error("Error Occured")
        }
    }

    const handleAllExport = async () => {
        setLoading(true)
        //const filterParams = insuranceState?.insuranceListFilters || { page_number: 1 }
        // const filterParams = { page_number: 1 }
        const exportData: any = await exportInsuranceAllData({})
        setLoading(false)

        if(exportData?.status === STATUS_SUCCESS && exportData.message) {
            toast.success(exportData.message)
        } else {
            toast.error("Error Occured")
        }
    }

    return (
        <React.Fragment>

            <FullPageLoader show={loading} />

            <div className="container-fluid">
                <div className="top-heading financer-lead-heding insurance-top-filer-heading">
                    <h1>{translations?.Insurance?.['Insurance Cases'] || translations?.commonMsg?.loading}</h1>
                    <div className="row">

                        {
                            FEATURE_LISTING['INSURANCE_LIST']['BULK_UPLOAD_APPLICATION'] && HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['bulk_upload_application'], accessType: 'edit', assignUserId: authUserInfo?.user_data?.id }) &&
                            <button className="btn-line m-sm-r" onClick={() => setBulkUploadModal(!bulkUploadModal)}>
                                <span>Bulk Upload Application</span>
                                {/* <i className="ic-add"></i> */}
                            </button>
                        }
                        {
                            FEATURE_LISTING['INSURANCE_LIST']['ADD_NEW_APPLICATION'] && HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['dashboard_page'], accessType: 'edit' }) &&
                            <button className="btn-line m-sm-r" onClick={addNewApp}>
                                <span>{translations?.Insurance?.ADD_NEW_APPLICATION}</span>
                                <i className="ic-add"></i>
                            </button>
                        }
                    </div>
                </div>
                <div className="loan-filter-bg">

                    <div className="top-filter-bg">
                        <InsuranceListTopFilter submitHandler={(filterParams: any) => { updateListFromChlid(filterParams); }} resetSort={()=> {setListSort(translations?.Insurance?.['INSURANCE_LIST_SORT'][0] || translations?.commonMsg?.loading); updateUrl('resetAll');} } loader={(params: any) => setLoading(params)}/>
                        <div className="selected-chips">
                            <ul>
                                {
                                    makeFilterChips()
                                }


                            </ul>
                        </div>
                    </div>


                    <Tab.Container id="left-tabs-example" defaultActiveKey={HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['my_cases'], accessType: 'isVisible' }) ? "second" : "second"}>

                        <Nav variant="pills" className="flex-column tab-line nav nav-pills"
                            onSelect={(k) => activeTabHandler(k)}
                        >
                            <div className="tab-list">
                                {
                                    HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['my_cases'], accessType: 'isVisible' }) &&
                                    <Nav.Item>
                                        <Nav.Link eventKey="first" disabled={!(paginationData && paginationData['myCasesCount'])}>
                                            My Cases ({(paginationData && paginationData['myCasesCount']) || 0})</Nav.Link>
                                    </Nav.Item>
                                }

                                <Nav.Item>
                                    <Nav.Link eventKey="second" disabled={!(paginationData && paginationData['allCasesCount'])}> {translations.Insurance?.['All Cases'] || translations.commonMsg?.loading} ({(paginationData && paginationData['allCasesCount']) || 0})</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="third" disabled={!(paginationData && paginationData['disbursedCasesCount'])}>
                                         {translations.Insurance?.['Disbursed Cases'] || translations.commonMsg?.loading} ({(paginationData && paginationData['disbursedCasesCount']) || 0})</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="fourth" disabled={!(paginationData && paginationData['lostCasesCount'])} >
                                         {translations.Insurance?.['Lost Cases'] || translations.commonMsg?.loading} ({(paginationData && paginationData['lostCasesCount']) || 0})</Nav.Link>
                                </Nav.Item>


                            </div>

                            <div className="btn-submit-reset top-btn-none">
                                 {
                                    insuranceList?.length 
                                        && 
                                    (authUserInfo?.user_data?.report_access && authUserInfo?.user_data?.report_access === 1)
                                    //commonState?.common?.export_user_ids?.includes(authUserInfo?.user_data?.id)
                                        ?
                                        <button className="btn-primary btn-width-auto" onClick={handleAllExport}>{translations.Insurance?.['Export_All_Data'] || translations.commonMsg?.loading}</button>
                                        :
                                        ""
                                }


                                {
                                    insuranceList?.length
                                        ?
                                        <button className="btn-primary btn-width-auto" onClick={handleExport}>{translations.Insurance?.['Export Data'] || translations.commonMsg?.loading}</button>
                                        :
                                        <button className="btn-primary btn-width-auto" disabled={true}>{translations.Insurance?.['Export Data'] || translations.commonMsg?.loading}</button>
                                }
                            </div>

                            <div className="sorting-filter-cls">

                                <ReactSelect options={translations?.Insurance?.['INSURANCE_LIST_SORT'] || translations?.commonMsg?.loading} value={listSort?.value ? listSort : translations?.Insurance?.['INSURANCE_LIST_SORT']?.[0] || translations?.commonMsg?.loading} handleChange={(e: any, fieldKey: string) => sortByhandleChange(e)} placeholder={""} fieldKey="" disableMargin={true} />

                            </div>

                        </Nav>


                        <Tab.Content>
                            <Tab.Pane eventKey="first">

                                <InsuranceListTable insuranceList={insuranceList} paginationData={paginationData} getInsuranceListing={getInsuranceListing} selectedFilters={selectedFilters} assignUsers={assignUsers} />

                            </Tab.Pane>
                            <Tab.Pane eventKey="second">


                                <InsuranceListTable insuranceList={insuranceList} paginationData={paginationData} getInsuranceListing={getInsuranceListing} selectedFilters={selectedFilters} assignUsers={assignUsers} />
                            </Tab.Pane>
                            <Tab.Pane eventKey="third">

                                <InsuranceListTable insuranceList={insuranceList} paginationData={paginationData} getInsuranceListing={getInsuranceListing} selectedFilters={selectedFilters} assignUsers={assignUsers} />
                            </Tab.Pane>

                            <Tab.Pane eventKey="fourth">

                                <InsuranceListTable insuranceList={insuranceList} paginationData={paginationData} getInsuranceListing={getInsuranceListing} selectedFilters={selectedFilters} assignUsers={assignUsers} />

                            </Tab.Pane>
                        </Tab.Content>

                    </Tab.Container>




                </div>

                {
                    bulkUploadModal
                    &&
                    <div className={`calculator-popup davition-popup bulk-upload-popup`}>
                        <Modal show={bulkUploadModal} handleClose={() => setBulkUploadModal(false)} >
                            <div className="modal-header">
                                <h2>{`Bulk Upload Application`}</h2>
                            </div>
                            <div className="modal-body" >
                                <div className="bulk-upload-history-content">
                                    <BulkImportModal setUpdateModal={{setUpdateModal:bulkUploadModal, type:"bulk_upload", title: "Bulk Upload Application"}} type="agencyBulkUploadApplications" closeBulkUploadModal={()=>setBulkUploadModal(false)}/>
                                    
                                </div>
                                
                                    
                            </div>
                        </Modal>
                    </div>
                }
            </div>

            
        </React.Fragment>
    )
}

export default InsuranceList;
